import React from 'react';

import Wrapper from './Wrapper/Wrapper';

function App() {

  return (
    <div>
      < Wrapper />
    </div>
  )
}

export default App;
